export default __webpack_public_path__ + "static/media/3.2a7fa7bd.jpg";